import script from "./OnboardingTest.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingTest.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingTest.vue?vue&type=style&index=0&id=004ba13a&scoped=true&lang=css"
import "./OnboardingTest.vue?vue&type=style&index=1&id=004ba13a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-004ba13a"]])

export default __exports__